import SetupRmNumberSmsModal from './setup-rm-number-sms-modal.vue'
export default SetupRmNumberSmsModal
